var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('vs-chip',{staticStyle:{"height":"60%","top":"20%"},attrs:{"color":_vm.statusColor(_vm.params.value, _vm.params.data.id)}},[_vm._v(_vm._s(_vm.params.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }